export default __webpack_public_path__ + "static/get-quote-e4cb44ace05a0178582b50202294a540.jpg";